/* eslint-disable react/jsx-no-target-blank */
import {useIntl} from 'react-intl'
import {AsideClientMenu} from '../../../../app/client/AsideClientMenu'
import {AsideSystemMenu} from '../../../../app/routing/AsideSystemMenu'
import {AsideMenuItem} from './AsideMenuItem'

export function AsideMenuMain() {
  const intl = useIntl()

  return (
    <>
      <AsideMenuItem
        to='/dashboard'
        icon='/media/icons/duotune/art/art002.svg'
        title={intl.formatMessage({id: 'MENU.DASHBOARD'})}
        fontIcon='bi-app-indicator'
      />

      <AsideClientMenu />

      <AsideSystemMenu />

      <div className='menu-item'>
        <div className='menu-content'>
          <div className='separator mx-1 my-4'></div>
        </div>
      </div>
      {/*<div className='menu-item'>*/}
      {/*    <a*/}
      {/*        target='_blank'*/}
      {/*        className='menu-link'*/}
      {/*        href={process.env.REACT_APP_PREVIEW_DOCS_URL + '/docs/changelog'}*/}
      {/*    >*/}
      {/*        <span className='menu-icon'>*/}
      {/*            <KTSVG path='/media/icons/duotune/general/gen005.svg' className='svg-icon-2' />*/}
      {/*        </span>*/}
      {/*        <span className='menu-title'>Changelog {process.env.REACT_APP_VERSION}</span>*/}
      {/*    </a>*/}
      {/*</div>*/}
    </>
  )
}
